  // Product search form handling
  const searchForm = document.querySelector('.woocommerce-product-search');
  if (searchForm) {
    const searchInput = searchForm.querySelector('input[name="s"]');
    const searchButton = searchForm.querySelector('button[type="submit"]');

    // Handle form submission
    searchForm.addEventListener('submit', (e) => {
      const searchValue = searchInput.value.trim();
      
      // If search is empty, prevent submission and clear any existing search
      if (searchValue === '') {
        e.preventDefault();
        // Remove 's' parameter from URL and reload
        const url = new URL(window.location.href);
        url.searchParams.delete('s');
        window.location.href = url.toString();
        return;
      }
      
      // Form will submit normally with the search value
    });

    // Allow Enter key to submit
    if (searchInput) {
      searchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          searchForm.dispatchEvent(new Event('submit'));
        }
      });
    }
  }